export default "__VITE_ASSET__nbOY6HxK__"